<script setup lang="ts">
import * as echarts from 'echarts/core';
import { SankeyChart } from 'echarts/charts';
import { CanvasRenderer } from 'echarts/renderers';
echarts.use([SankeyChart, CanvasRenderer]);

const option = ref({
  tooltip: {
      trigger: 'item',
      triggerOn: 'mousemove'
    },
  series: {
    type: 'sankey',
    layout: 'none',
    emphasis: {
      focus: 'adjacency'
    },
    data: [
      { name: 'FHVW' },
      { name: 'Delf' },
      { name: 'JPL' },
      { name: 'PHVW' },
      { name: 'LR' },
      { name: 'LP' },
      { name: 'Order1' },
      { name: 'Order2' },
      { name: 'Order3' },
      { name: 'Order4' },
      { name: 'Order5' }
    ],
    links: [
      { source: 'FHVW', target: 'LR', value: 150 },
      { source: 'FHVW', target: 'LP', value: 200 },
      { source: 'Delf', target: 'LR', value: 200 },
      { source: 'Delf', target: 'LP', value: 250 },
      { source: 'JPL', target: 'LR', value: 250 },
      { source: 'JPL', target: 'LP', value: 300 },
      { source: 'PHVW', target: 'LR', value: 300 },
      { source: 'PHVW', target: 'LP', value: 350 },
      { source: 'LR', target: 'Order1', value: 100, lineStyle: { color: 'red' } },
      { source: 'LP', target: 'Order1', value: 150, lineStyle: { color: 'red' } },

      { source: 'LR', target: 'Order1', value: 100 },
      { source: 'LR', target: 'Order2', value: 150 },
      { source: 'LR', target: 'Order3', value: 200 },
      { source: 'LR', target: 'Order4', value: 250 },
      { source: 'LR', target: 'Order5', value: 300 },
      { source: 'LP', target: 'Order1', value: 150 },
      { source: 'LP', target: 'Order2', value: 200 },
      { source: 'LP', target: 'Order3', value: 250 },
      { source: 'LP', target: 'Order4', value: 300 },
      { source: 'LP', target: 'Order5', value: 350 }
    ]
  }
});
</script>

<template>
  <v-chart :option="option" autoresize />
</template>
